export default "__VITE_ASSET__C0EK5BlL__"